import { Component, Input, OnChanges, inject } from '@angular/core';
import { TableColumn, TableComponent } from '@rbb/ng-web-template-lib';
import { ProcessListItem } from '../../data/process-list-item';
import { Router, RouterLink } from '@angular/router';
import { uniq } from 'lodash';
import { UtilService } from '../../services/util.service';
import { ProcessStatus } from '../../types/process-status';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-processes-table',
  templateUrl: './processes-table.component.html',
  styleUrls: ['./processes-table.component.css'],
  imports: [RouterLink, DatePipe, TableComponent]
})
export class ProcessesTableComponent implements OnChanges {
  private router = inject(Router);
  utilService = inject(UtilService);

  @Input() processes: ProcessListItem[] | undefined;

  columns: TableColumn[] = [];

  ngOnChanges(): void {
    this.columns = [
      { name: 'Nr.', field: 'number', type: 'number' },
      { name: 'Formular', field: 'formName', type: 'string',
        selections: uniq((this.processes?.map(process => process.formName).filter(s => s) as string[])).sort().map(formName => ({ name: formName, value: formName })),
        multipleSelections: true },
      { name: 'Datenauszug', field: 'previewData', type: 'string[]' },
      { name: 'Vorname', field: 'firstName', type: 'short-string' },
      { name: 'Nachname', field: 'lastName', type: 'short-string' },
      { name: 'Benutzername', field: 'username', type: 'short-string' },
      { name: 'Datum', field: 'timestamp', type: 'Date' },
      { name: 'Status', field: 'status', type: 'string', selections: [
        { name: 'Entwurf', value: 'DRAFT' },
        { name: 'Warte auf Genehmigung', value: 'SENT' },
        { name: 'Warte auf Bearbeitung', value: 'APPROVED' },
        { name: 'Wird bearbeitet', value: 'IN_PROGRESS' },
        { name: 'Abgeschlossen', value: 'FINISHED' },
        { name: 'Bearbeitung zurückgewiesen', value: 'REJECTED' },
        { name: 'Übermittelt', value: 'TRANSMITTED' },
        { name: 'Übermittlung fehlgeschlagen', value: 'TRANSMISSION_FAILED' },
        { name: 'Veraltet', value: 'OLD' },
        { name: 'Abgelehnt', value: 'DECLINED' },
        { name: 'Storniert', value: 'CANCELED' },
        { name: 'Storniert nach Genehmigung', value: 'CANCELED_AFTER_APPROVED' },
        { name: 'Bearbeitungsstatus unbekannt', value: 'UNKNOWN' }
      ], multipleSelections: true },
      { name: 'Bearbeiter/in', field: 'lastOperator', type: 'string' },
      { name: 'Kommentar zum Beginn der Bearbeitung', field: 'preProgressComment', type: 'string' },
      { name: 'Kommentar zum Abschluss der Bearbeitung', field: 'progressComment', type: 'string' },
      { name: 'Wiedervorlage', field: 'resubmitted', type: 'Date' },
      { name: '', field: 'open', type: null }
    ];
  }

  routeToProcess(process: ProcessListItem, target = '_self'): void {
    if (target === '_self') {
      this.router.navigate(['/processes', process.id]).then();
    } else {
      window.open('processes/' + process.id, target);
    }
  }

  protected readonly ProcessStatus = ProcessStatus;
}
